export default "__VITE_ASSET__5a3a1fa4__"